//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: { // 接受父组件传递的值
    liveRotation: {
      type: Array, default: () => []
    }
  },
  data () {
    return {
      languageCode: this.$store.state.LanguageCode, // 当前选择的语言
      countryCode: this.$store.state.CountryCode // 当前选择的国家
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {

  }
}
